import { render, staticRenderFns } from "./Input2.vue?vue&type=template&id=3107844f&scoped=true&"
import script from "./Input2.vue?vue&type=script&lang=js&"
export * from "./Input2.vue?vue&type=script&lang=js&"
import style0 from "./Input2.vue?vue&type=style&index=0&id=3107844f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3107844f",
  null
  
)

component.options.__file = "Input2.vue"
export default component.exports